/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetIoeContent200ResponseFaqsInner } from './GetIoeContent200ResponseFaqsInner';
import {
    GetIoeContent200ResponseFaqsInnerFromJSON,
    GetIoeContent200ResponseFaqsInnerFromJSONTyped,
    GetIoeContent200ResponseFaqsInnerToJSON,
    GetIoeContent200ResponseFaqsInnerToJSONTyped,
} from './GetIoeContent200ResponseFaqsInner';

/**
 * Successful response
 * @export
 * @interface GetIoeContent200Response
 */
export interface GetIoeContent200Response {
    /**
     * Human-readable title of the IoE check.
     */
    title?: string;
    /**
     * Structured content sections for this IoE check.
     */
    faqs?: Array<GetIoeContent200ResponseFaqsInner>;
}

/**
 * Check if a given object implements the GetIoeContent200Response interface.
 */
export function instanceOfGetIoeContent200Response(value: object): value is GetIoeContent200Response {
    return true;
}

export function GetIoeContent200ResponseFromJSON(json: any): GetIoeContent200Response {
    return GetIoeContent200ResponseFromJSONTyped(json, false);
}

export function GetIoeContent200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIoeContent200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'faqs': json['faqs'] == null ? undefined : ((json['faqs'] as Array<any>).map(GetIoeContent200ResponseFaqsInnerFromJSON)),
    };
}

export function GetIoeContent200ResponseToJSON(json: any): GetIoeContent200Response {
    return GetIoeContent200ResponseToJSONTyped(json, false);
}

export function GetIoeContent200ResponseToJSONTyped(value?: GetIoeContent200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'faqs': value['faqs'] == null ? undefined : ((value['faqs'] as Array<any>).map(GetIoeContent200ResponseFaqsInnerToJSON)),
    };
}

